import { Component, OnInit, OnDestroy } from '@angular/core';
import { RadiosDataService } from 'src/app/services/radios-data.service';
import { RadioService } from 'src/app/services/radio.service';
import { Radio } from 'src/app/models/radio';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-radio-online',
  templateUrl: './radio-online.component.html',
  styleUrls: ['./radio-online.component.scss']
})
export class RadioOnlineComponent implements OnInit, OnDestroy {
 playListAM=false;
  playListFM=false;
  playListUniversal=false;
  audioRadio:any;
  valuecenFM=100;
  valuecenAM=100;
  valueuniFM=100;
  radios: Radio[];
  subscription: Subscription = new Subscription;
  constructor(public serviceRadio : RadiosDataService, private radioServ: RadioService) {
    this.radioServ.getVisible().then(radios => this.radios = radios);
   }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
  }



  sliderOnChangeCenFM(number:any){
    let bool= ((this.serviceRadio.RADIOFM961 && this.serviceRadio.PLAYLISTONOFF) ? true : false);
    if(bool)
    {
      this.audioRadio= document.getElementById('audioaux');
      let covertToVolume= number *0.01;
      this.audioRadio.volume= covertToVolume;
    }
    else{
      console.log("unauthorized action");
    }

  }
  sliderOnChangeUniFM(number:any){
    let bool= ((this.serviceRadio.RADIOUNIVERSAL && this.serviceRadio.PLAYLISTONOFF) ? true : false);
    if(bool){
      this.audioRadio= document.getElementById('audioaux');
      let covertToVolume= number *0.01;
      this.audioRadio.volume= covertToVolume;
    }
    else{
      console.log("unauthorized action");
    }

  }
  sliderOnChangeCenAM(number:any){
    let bool= ((this.serviceRadio.RADIOAM247 && this.serviceRadio.PLAYLISTONOFF) ? true : false);
    if(bool){
      this.audioRadio= document.getElementById('audioaux');
      let covertToVolume= number *0.01;
      this.audioRadio.volume= covertToVolume;
    }
    else{
      console.log("unauthorized action");
    }

  }

  playRadioAM(){
    this.pauseAll();

     this.serviceRadio.RADIOAM247=true;
     this.serviceRadio.RADIOFM961=false;
     this.serviceRadio.RADIOUNIVERSAL=false;
     this.serviceRadio.PLAYLISTONOFF=true;
     this.playListAM=true;
     this.serviceRadio.playCentroAM();


  }
  playRadioFM(){
    this.pauseAll();

     this.serviceRadio.RADIOFM961=true;
     this.serviceRadio.RADIOAM247=false;
     this.serviceRadio.RADIOUNIVERSAL=false;
     this.serviceRadio.PLAYLISTONOFF=true;
     this.playListFM=true
     this.serviceRadio.playCentroFM();



  }

  playRadioUniversal(){
    this.pauseAll();

     this.serviceRadio.RADIOUNIVERSAL=true;
     this.serviceRadio.RADIOFM961=false;
     this.serviceRadio.RADIOAM247=false;
     this.serviceRadio.PLAYLISTONOFF=true;
     this.playListUniversal=true;
     this.serviceRadio.playradioUniversal();
  }

  pauseAll(){
   this.serviceRadio.RADIOAM247=false
   this.serviceRadio.RADIOUNIVERSAL=false;
   this.serviceRadio.RADIOFM961=false;
   this.serviceRadio.PLAYLISTONOFF=false;
   this.playListAM=false;
   this.playListFM=false;
   this.playListUniversal=false;
   this.serviceRadio.pause();
  }
}
